export const ALLOW_QUERY_INDICES = {
  audit: 'bioaudit-sn-audit',
  issue: 'bioaudit-sn-issue'
};

export const baseQuery = {
  'aggregations': [], // to define on the query component and the dashboard level
  'indices': [], // to define on the query component
  'size': 0,
  'startAt': 0,
  'withHits': false
};

const incidentsDistribution = {
  query: {'query': 'issuesByTypes'},
  'filters': {
    'type': 'RANGE',
    'field': 'metadata.date',
    'from': '2020-10-01T04:00:00.000Z',
    'to': '2023-01-01T04:59:59.999Z',
    'isDate': false
  }
};

const incidencesByCategory = {
  query: {'query': 'issuesByCategories'},
  'filters': {
    'type': 'RANGE',
    'field': 'metadata.date',
    'from': '2020-10-01T04:00:00.000Z',
    'to': '2023-01-01T04:59:59.999Z',
    'isDate': false
  }
};

const auditLog = {
  query: {'query': 'executedAudits'},
  'filters': {
    'type': 'RANGE',
    'field': 'metadata.date',
    'from': '2020-10-01T04:00:00.000Z',
    'to': '2023-01-01T04:59:59.999Z',
    'isDate': false
  }
};

export const queries = {
  incidentsDistribution,
  incidencesByCategory,
  auditLog
};

export const defaultStaleTime = 60000;

export const commonQueryConfig = {
  refetchOnWindowFocus: false,
  staleTime: defaultStaleTime,
};
